import { useEffect } from "react"

const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    document.title = `Ki Partner Portal | ${title}`
  }, [title])
}

export default useDocumentTitle
